import { render, staticRenderFns } from "./BaseQrCode.vue?vue&type=template&id=1bf6a71e&"
import script from "./BaseQrCode.vue?vue&type=script&lang=js&"
export * from "./BaseQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports